import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import GraphicChip from "../../Components/GraphicChip";
import {LaunchRounded} from "@mui/icons-material";
import { selectUserFields } from '../../Store/slices/user.slice';


const PortfolioPageCard = ({size})=>{
    const navigate = useNavigate();
    const pages = useSelector((state) => selectUserFields(state, 'page_details'));

    return (
        <GraphicChip
            imgUrl={'https://storage.googleapis.com/finiat-web-static-resources/NEWEST-7-9-2024/color-spalsh-cold-black-bg.jpeg'}
            title="Portfolio Pages"
            tag={pages.length}
            backdropFilter={'blur(0px)'}
            icon={<LaunchRounded style={{ fontSize: '18px' }} />}
            backgroundSize={'100% 100%'}
            onClick={()=>navigate('/pages')}
            showIcon={true}
            size={size}

        />
    )
}

export default PortfolioPageCard;